// same for problem kendaraan and problem kendaraan trado
// (what differs between the two is in problem-kendaraan/utils and problem-kendaraan-trado/utils)
export const apiUrl = "problemkendaraan";
export const fetchOrderBy = "tanggal";
export const fetchOrderMethod = "DESC";

export const editorDefaultValue = { keterangan: "", label_grup: "" };

// all the problems are pulled at once, the tables are paged locally
export const fetchTake = 10000;

// paging of the table: first row of the page and rows per page
export const initialPaging = { first: 0, rows: 10 };
export const rowsPerPageOptions = [5, 10, 20, 50];

// status of a problem that is solved
export const solvedStatus = 3;

// Tabs of the page: the "status" field of a problem. Each tab has ONE table with its title.
//   alertCount: the tab shows how many problems it has (once the data is pulled), these problems are still open
export const problemStatusTabs = [
  { status: 1, label: "Baru", title: "PROBLEM BARU", alertCount: true },
  { status: 2, label: "Schedule", title: "PROBLEM SCHEDULE", alertCount: true },
  { status: 3, label: "Solved", title: "PROBLEM SOLVED" },
  { status: 4, label: "Ignore", title: "PROBLEM IGNORE" },
];
